import { EventEmitter, Injectable } from '@angular/core';
import { AuthTask } from '../task-list/models/auth-task.model';
import { ImageToSave } from '../images/models/image-to-save.model';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  public valueChanged = new EventEmitter<boolean>();
  public videoChanged = new EventEmitter<boolean>();
  public videoSent = new EventEmitter<boolean>();
  public isSendingVideo = new EventEmitter<boolean>();
  public uploadSucceded = new EventEmitter<boolean>();
  public attemptsExceeded = new EventEmitter();
  public closeComponent = new EventEmitter();
  public declineTask = new EventEmitter<AuthTask>();
  public closeModal = new EventEmitter();
  public currentUploadProgress = new EventEmitter<number>();
  public suspendPurchase = new EventEmitter();
  public answersSaved = new EventEmitter<boolean>();
  public performContinuePurchase = new EventEmitter<boolean>();
  public authAswersChanged = new EventEmitter<boolean>();
  public confettiExplosion = new EventEmitter<boolean>();
  public backgroundImageUpload = new EventEmitter<ImageToSave>();
}
